// extracted by mini-css-extract-plugin
module.exports = {"main":"payments_main__1TTn5","title":"payments_title__KGViC","grid":"payments_grid__2AZZK"};